// To test if the external referrer is one of these search engines
const top5SearchEngineRegex = /(google|bing|yahoo|baidu|duckduckgo)/i;

export function isTopFiveSearchEngine (externalReferrer: string): boolean {
  return top5SearchEngineRegex.test(externalReferrer);
}